<template>
  <div class="picker-goods">
    <el-form ref="form" :model="form" label-width="150px">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>

        <el-form-item label="送礼分享标题">
          <el-input v-model="form.share_title"></el-input>
        </el-form-item>
        <el-form-item label="送礼分享图片">
          <div>
            <div @click="handleHomeImgChange('share')" class="upload-box">
              <img v-if="form.share_image" :src="wximageurl + form.share_image" class="avatar" />
              <i v-else class="iconfont icon-camera"></i>
            </div>
            <div class="frm-tips">上传图片尺寸宽高比例为5:4</div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="送礼说明页面">
          <el-tag type="info" effect="plain" @click="handleCustomWgtPage">
            <span>{{form.share_custom_page_id ? form.share_custom_page_id : '请选择自定义页面' }}</span>
            <i class="el-icon-edit"></i>
          </el-tag>
        </el-form-item> -->
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>送礼卡封面</span>
          <el-button type="primary" style="float: right;" @click="addPicsImg">添加封面</el-button>
        </div>
        <div class="pics-box">
          <ul class="goodspic-wrap">
            <draggable v-model="form.card_images" :options="dragIssuesOptions" class="components-view">
              <li v-for="(item, index) in form.card_images" :key='index' class="goodspic">
                <div class="tiem-top" @mouseenter="picsEnter(index, 'pic')" @mouseleave="picsLeave('pic')">
                  <img :src="wximageurl + item.image_url" />
                  <div class="goodspic-mask" :class="(picsCurrent == index) ? 'on' : ''">
                    <!-- <div class="iconfont icon-trash-alt" @click="removePicsImg(index)"></div> -->
                    <div class="iconfont icon-arrows-alt"></div>
                  </div>
                </div>
                <div class="tiem-name">{{ item.name }}</div>
                <div class="tiem-bottom">
                  <el-button type="text" @click="editPicsImg(item, index)">编辑</el-button>
                  <div class="line"></div>
                  <el-button type="text" @click="delPicsImg(index)">删除</el-button>
                </div>
              </li>
            </draggable>
          </ul>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>送礼祝福语</span>
          <el-button type="primary" style="float: right;" @click="addAssort">添加祝福语</el-button>
        </div>
        <div class="pics-box">
          <ul class="goodspic-wrap">
            <draggable v-model="form.blessings" :options="dragIssuesOptions" class="components-view">
              <li v-for="(item, index) in form.blessings" :key='index' class="goodspic">
                <div class="tiem-top" @mouseenter="picsEnter(index, 'assort')" @mouseleave="picsLeave('assort')">
                  <div class="tiem-name item-blessing">{{ item.blessing }}</div>
                  <div class="goodspic-mask" :class="(assortCurrent == index) ? 'on' : ''">
                    <!-- <div class="iconfont icon-trash-alt" @click="removePicsImg(index)"></div> -->
                    <div class="iconfont icon-arrows-alt"></div>
                  </div>
                </div>
                <div class="tiem-bottom">
                  <el-button type="text" @click="editAssort(item, index)">编辑</el-button>
                  <div class="line"></div>
                  <el-button type="text" @click="delAssort(index)">删除</el-button>
                </div>
              </li>
            </draggable>
          </ul>
        </div>
      </el-card>

      <el-button style="margin-left: 50%;" type="primary" @click="onSubmit">保存</el-button>
    </el-form>
    <imgPicker :dialog-visible="homeimgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
      @closeImgDialog="closeHomeImgDialog"></imgPicker>
  </div>
</template>

<script>
import imgPicker from '@/components/imageselect'
import { postGiftordersetting, getGiftordersetting, putGiftingorderblessingGroup, giftingorderblessingGroupDetail } from '@/api/giving'
import { dragIssuesOptions } from '@/consts'
import draggable from 'vuedraggable'
import { useDialog } from '@shopex/finder'

const commonActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '保存', key: 'save', type: 'primary', size: 'default' }
]

export default {
  components: {
    imgPicker,
    draggable
  },
  data() {
    return {
      form: {
        share_title: '',
        share_image: '',
        share_custom_page_id: '',
        card_images: [],
        blessings: [],
      },
      dragIssuesOptions,
      homeimgDialog: false,
      isGetImage: false,
      imgPickerType: '',
      picsCurrent: -1,
      assortCurrent: -1
    }
  },
  mounted() {
    this.groupDetail(this.$route.query.id)
    // getGiftordersetting().then(res => {
    //   const info = res.data.data
    //   // 将info和form合并
    //   this.form = Object.assign({}, this.form, info)
    // })
  },
  methods: {
    groupDetail(id) {
      giftingorderblessingGroupDetail({ id }).then(res => {
        this.form = res.data.data
      })
    },
    handleHomeImgChange(t) {
      this.homeimgDialog = true
      this.isGetImage = true
      this.imgPickerType = t
    },
    pickImg(data) {
      if (this.imgPickerType == 'share') {
        this.form.share_image = data.url
      } else {
        this.form.card_images.push(data.url)
      }
      this.homeimgDialog = false
    },
    closeHomeImgDialog() {
      this.homeimgDialog = false
    },
    async handleCustomWgtPage() {
      const { data } = await this.$picker.pages({ multiple: false, includesrecommend: true })
      this.form.share_custom_page_id = data[0].id
    },
    removePicsImg: function (index) {
      this.form.card_images.splice(index, 1)
    },
    picsEnter(index, t) {
      if (t == 'pic') {
        this.picsCurrent = index
      } else if (t == 'assort') {
        this.assortCurrent = index
      }
    },
    picsLeave(t) {
      if (t == 'pic') {
        this.picsCurrent = -1
      } else if (t == 'assort') {
        this.assortCurrent = -1
      }
    },
    // 添加封面图
    addPicsImg() {
      useDialog(null, {
        title: `添加封面图`,
        width: '50%',
        info: {},
        component: () => import('./comps/add-imgs.vue'),
        actions: commonActions
      }).then((data) => {
        this.form.card_images.push(data)
      })
    },
    // 添加祝福语
    addAssort() {
      useDialog(null, {
        title: `添加祝福语`,
        width: '50%',
        // info: item,
        component: () => import('./comps/add-blessing-text'),
        actions: commonActions
      }).then((data) => {
        this.form.blessings = [...this.form.blessings, ...data]
      })
    },
    // 编辑封面图
    editPicsImg(item, index) {
      useDialog(null, {
        title: `编辑封面图`,
        width: '50%',
        info: item,
        component: () => import('./comps/add-imgs.vue'),
        actions: commonActions
      }).then((data) => {
        let arr = JSON.parse(JSON.stringify(this.form.card_images))
        arr[index] = data
        this.form.card_images = arr
      })
    },
    // 编辑祝福语
    editAssort(item, index) {
      useDialog(null, {
        title: `编辑祝福语`,
        width: '50%',
        info: item,
        component: () => import('./comps/edit-blessing-text.vue'),
        actions: commonActions
      }).then((data) => {
        const { name } = data
        let arr = JSON.parse(JSON.stringify(this.form.blessings))
        arr[index].blessing = name
        this.form.blessings = arr
      })
    },
    // 删除封面图
    delPicsImg(index) {
      this.form.card_images.splice(index, 1)
    },
    // 删除祝福语
    delAssort(index) {
      this.form.blessings.splice(index, 1)
    },
    onSubmit() {
      let blessings_list = [], images_list = []

      this.form.blessings.forEach((item,index) => {
        blessings_list.push({ ...item, sort: index + 1})
      })
      this.form.card_images.forEach((item,index) => {
        images_list.push({ ...item, sort: index + 1 })
      })
      this.form.blessings = blessings_list
      this.form.card_images = images_list
      putGiftingorderblessingGroup(this.form).then(res => {
        this.$message.success('保存成功')
      })
    }
  }
}
</script>
<style scoped type="text/css" lang="scss">
.form-search {
  margin-bottom: 10px;
}

.form-name {
  width: 200px !important;
}

.el-icon-edit {
  margin-left: 30px
}

.icon-camera {
  font-size: 30px;
  color: #ccc;
}

.pics-box {
  overflow: hidden;

  .goodspic-wrap {
    float: left;
    margin-right: 5px;
    overflow: hidden;
    display: flex;

    .goodspic {
      width: 160px;
      float: left;
      margin: 0 5px 10px;
      border: 1px solid #ddd;
      border-radius: 8px;
      overflow: hidden;

      .tiem-top {
        // width: 150px;
        // height: 150px;
        position: relative;
      }

      .tiem-name {
        height: 30px;
        line-height: 30px;
        text-align: center;
      }

      .item-blessing {
        height: 70px;
        line-height: 14px;
        padding: 4px
      }

      .tiem-bottom {
        display: flex;
        justify-content: space-around;
        border-top: 1px solid #ddd;

        .line {
          width: 1px;
          background: #ddd;
        }
      }




      img {
        width: 150px;
        height: 150px;
      }

      .goodspic-mask {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .2);
        cursor: pointer;

        &.on {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .iconfont {
          margin: 0 8px;
          font-size: 20px;
          color: #fff;
        }
      }
    }
  }

  .upload-box {
    display: inline-block;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
}
</style>